import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { BHAREE_BASE_URL_LOCAL } from "../../../config/config.url";
import PageSpinner from "../../common/PageSpinner";
import { Form, Row, Col, Button } from "react-bootstrap";
import "./index.css";
import isEmpty from "../../../utils/is-Empty";
import { getMonthOptionsFromCreatedAt } from "../../../utils/getMonthsOptions";
import Select from "react-select";
import { toast } from "react-toastify";
import { tableStructures } from "../../../helpers/table-structures";
import CustomTable from "../common/CustomTable";
import { exportTotalTripsToCSV } from "../../../utils/exportOrdersToCSV";

const ReportsMonthlyTrips = () => {
  const dispatch = useDispatch();
  const [monthOptions, setMonthOptions] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [sellerOptions, setSellerOptions] = useState([]);
  const [selectedSeller, setSelectedSeller] = useState(null);
  const [totalTrips, setTotalTrips] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);

  const { auth } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    if (!isEmpty(auth) && auth?.loggedIn && auth?.user?.createdAt) {
      const monthOptions = getMonthOptionsFromCreatedAt(auth?.user?.createdAt);
      setMonthOptions(monthOptions);
      setSellerOptions([]);
      setSelectedSeller(null);
    }
  }, [auth]);

  useEffect(() => {
    if (monthOptions.length) {
      // Current month is always the last one
      setSelectedMonth(monthOptions[monthOptions.length - 1]);
    }
  }, [monthOptions]);

  useEffect(() => {
    if (!isEmpty(auth) && auth?.loggedIn && auth?.user?.id && !isEmpty(selectedMonth)) {
      getMonthlyTrips(auth?.user?.id, selectedMonth?.value);
    }
  }, [auth, selectedMonth]);

  useEffect(() => {
    if (!isEmpty(totalTrips) && totalTrips.length > 0) {
      let mFiltered = [...totalTrips];

      if (!isEmpty(selectedSeller)) {
        mFiltered = mFiltered.filter(
          (record) => record?.sellerInfo?.business_name === selectedSeller
        );
      }

      setFilteredData(mFiltered);
    }
  }, [totalTrips, selectedSeller]);

  const getMonthlyTrips = async (logisticPartnerId, selectedMonth) => {
    try {
      setSellerOptions([]);
      setSelectedSeller(null);
      setLoading(true);
      const response = await axios
        .post(
          BHAREE_BASE_URL_LOCAL + "/logistics/getMonthlyTrips",
          {
            logisticPartnerId,
            monthDate: selectedMonth, // e.g. "2026-01-01"
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.jwtToken}`,
            },
          }
        )
        .finally(() => {
          setLoading(false);
        });
      setLoading(false);

      if (!isEmpty(response?.data?.data) && response?.data?.data?.length > 0) {
        setTotalTrips(response?.data?.data);

        const uniqueNames = [
          ...new Set(response?.data?.data.map((u) => u.sellerInfo?.business_name).filter(Boolean)),
        ].sort((a, b) => a.localeCompare(b));
        setSellerOptions(uniqueNames);
      } else {
        setTotalTrips([]);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching monthly trips:", error);
      toast.error(error.response?.data || error);
    }
  };

  return (
    <>
      {loading && <PageSpinner />}
      <div className="mb-3 mt-3">
        <Row className="align-items-center px-3">
          {/* Left: Header */}
          {/* Header (left on desktop, full width on mobile) */}
          <Col xs={12} md={4} className="mb-2 mb-md-0">
            <h4 className="m-0">Total Trips (Count: {filteredData.length})</h4>
          </Col>
          <Col xs={12} md={8} className="d-flex justify-content-end">
            <Select
              className="ms-2"
              options={monthOptions}
              value={selectedMonth}
              onChange={setSelectedMonth}
              placeholder="Select Month"
              isClearable={false}
            />
            <Select
              className="ms-2"
              options={sellerOptions.map((name) => ({
                value: name,
                label: name,
              }))}
              value={selectedSeller ? { value: selectedSeller, label: selectedSeller } : null}
              onChange={(selected) => setSelectedSeller(selected?.value || "")}
              placeholder="Select Seller"
              isClearable
              isSearchable
            />
            <Button
              variant="primary"
              className="ms-2"
              onClick={() => {
                getMonthlyTrips(auth?.user?.id, selectedMonth?.value);
              }}
            >
              <i class="bi bi-search"></i>
            </Button>
            <Button
              variant="primary"
              className="ms-2"
              onClick={() => exportTotalTripsToCSV(totalTrips)}
              disabled={!totalTrips.length}
            >
              <i class="bi bi-download"></i>
            </Button>
          </Col>
        </Row>
        <Row className="m-0 mt-3">
          <CustomTable
            className="table-custom-class"
            columns={tableStructures.reports_total_trips}
            data={filteredData}
            enableRowActions={false}
            positionActionsColumn={"last"}
            enableTopToolbar={false}
            emptyTableMsg={"No data found"}
            enablePagination={true}
            enableBottomToolbar={true}
          />
        </Row>
      </div>
    </>
  );
};

export default ReportsMonthlyTrips;
